import { Map } from 'immutable';
import { createSelector } from 'reselect';
import { nullIfFirstArgNegative } from '@Utils';

import { alertResults } from '@Pages/Alerts/AlertsSelectors';
import { alertItemReducerKey } from './AlertItemConstants';

export function alertItemInfoBranch(state) {
  return state.get(alertItemReducerKey);
}

export function alertItemInfo(state, ownProps) {
  return alertItemInfoBranch(state).get(ownProps.id, Map());
}

export function currentRunId(state, ownProps) {
  return alertItemInfo(state, ownProps).get('currentRunId');
}

export const alertSelectedResult = createSelector(
  [alertResults, currentRunId],
  nullIfFirstArgNegative((results, runId) => {
    if (!runId) {
      return results.first();
    }
    return results.find((item) => item.get('runId') === runId, null, null);
  })
);

export const alertSelectedResultDate = createSelector(
  [alertSelectedResult],
  nullIfFirstArgNegative((selectedResult) => selectedResult.get('resultDate'))
);

export const alertSelectedResultHits = createSelector(
  [alertSelectedResult],
  nullIfFirstArgNegative((selectedResult) => selectedResult.get('hits'))
);

export const alertSelectedRunId = createSelector(
  [alertSelectedResult],
  nullIfFirstArgNegative((selectedResult) => selectedResult.get('runId'))
);
